import React from 'react';

const VideoSectionCard = ({ children, className, ...props }) => {
  const classNameList = `${
    className ? className + ' ' : ''
  }border p:large radius:medium`;

  return (
    <div className={classNameList} {...props}>
      {children}
    </div>
  );
};

export default VideoSectionCard;
